/**
 * EditMode - View component for move editing interface
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function EditMode({ value, onChange, onKeyDown, onSave, onCancel }) {
  return (
    <div style={styles.editContainer} onClick={(e) => e.stopPropagation()}>
      <input
        autoFocus
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        style={styles.editInput}
      />
      <button onClick={onSave}>Save</button>
      <button onClick={onCancel}>Cancel</button>
    </div>
  );
}

const styles = {
  editContainer: {
    display: 'flex',
    gap: 6,
    alignItems: 'center',
    justifyContent: 'center'
  },
  editInput: {
    fontFamily: 'monospace',
    fontSize: '1.1em',
    padding: '4px'
  }
};
